import styles from './AWSServiceLink.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const linkList = [
  {
    title: 'Amazon ECS',
    link: '/services/amazonecs/',
    imgSrc: '/img/common/aws_ecs.webp',
  },
  {
    title: 'AWS App Runnrer',
    link: '/services/awsapprunner/',
    imgSrc: '/img/common/aws_apprunner.webp',
  },
  {
    title: 'AWS CodePipeline',
    link: '/services/awscodepipeline/',
    imgSrc: '/img/common/aws_codepipeline.webp',
  },
  {
    title: 'AWS Fargate',
    link: '/services/awsfargate/',
    imgSrc: '/img/common/aws_fargate.webp',
  },
]

const AWSServiceLink: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.AWSLink} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>AWS運用支援</h2>
      <p className={styles.sectionRead}>クラウドネイティブに関連した、AWSの運用支援ページもご覧ください</p>
      <nav className={styles.AWSNav}>
        <ul className={styles.AWSNav__list}>
          {linkList.map((item, index) => (
            <li key={index} className={styles.AWSNav__list__item}>
              <a href={item.link} className={styles.AWSNav__list__item__link}>
                <figure className={styles.AWSNav__list__item__link__figure}>
                  <img
                    src={item.imgSrc}
                    alt={item.title}
                    width={40}
                    height={40}
                    className={styles.AWSNav__list__item__link__figure__image}
                  />
                </figure>
                <span className={styles.AWSNav__list__item__link__text}>{item.title}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <h2 className={styles.sectionTitle2}>AitriaはAWS パートナーネットワーク（APN）の認定パートナーです</h2>
      <section className={styles.awsPartner}>
        <div className={styles.awsPartner__item}>
          <figure className={styles.awsPartner__item__image}>
            <img src="/img/common/aws_amazon_ecs_delivery_partner.svg" alt="AWS Partner" width={80} height={80} />
          </figure>
          <div className={styles.awsPartner__item__cts}>
            <h3 className={styles.awsPartner__item__cts__title}>Amazon ECS Delivery Partner</h3>
            <p className={styles.awsPartner__item__cts__text}>
              AWSのフルマネージド型コンテナオーケストレーションサービス「Amazon Elastic Container
              Service（ECS）」に関して、豊富な知識と実績を有する企業に付与される認定です。
            </p>
          </div>
        </div>
        <div className={styles.awsPartner__item}>
          <figure className={styles.awsPartner__item__image}>
            <img
              src="/img/common/aws_select_tier_services_partner.svg"
              alt="Amazon Select Tier Services Partner"
              width={80}
              height={80}
            />
          </figure>
          <div className={styles.awsPartner__item__cts}>
            <h3 className={styles.awsPartner__item__cts__title}>Amazon Select Tier Services Partner</h3>
            <p className={styles.awsPartner__item__cts__text}>
              トレーニングと認証を受けた人員とともに、カスタマーエクスペリエンスを提供するパートナーです。特定のAWSサービスを定められた水準以上のレベルで提供できる企業に与えられます。
            </p>
          </div>
        </div>
      </section>
    </section>
  )
}

export default AWSServiceLink
